import { useLocation, useParams } from "react-router-dom";
import { useBoundStore } from "state/bound.store";
import { followedUserId } from "state/followedUser";

/**
 * The team member whose itinerary and profile are on screen, or null when the user is looking
 * at their own.
 *
 * `:userId` on the member route is the source. Detail routes pushed from that page (a flight,
 * a hotel) have no such segment, so the cards that push them carry the id in navigation state.
 */
export function useViewedUserId(): number | null {
  const { userId } = useParams();
  const location = useLocation();
  // A guest account browses as the user it follows, so with no member on screen that user
  // is the one being viewed.
  const guestFollowId = useBoundStore((s) => followedUserId(s.wpUser) ?? null);

  const fromRoute = Number.parseInt(userId ?? "", 10);
  if (Number.isFinite(fromRoute)) return fromRoute;

  const fromState = (location.state as Record<string, unknown> | null)?.viewedUserId;
  if (typeof fromState === "number") return fromState;

  return guestFollowId;
}
